import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  testimony: string[];
}

const TestimonyPanel: React.FC<Props> = ({ testimony }) => {
  const { t } = useTranslation();
  return (
    <div className="testimony-panel">
      <h2>{t('testimony.title')}</h2>
      <div className="testimony-content">
        {testimony.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
};

export default TestimonyPanel;
